"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.validate = void 0;

var _lodash = require("lodash");

var _inputValidator3 = _interopRequireDefault(require("./inputValidator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var validate = function validate() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$displayName = _ref.displayName,
      displayName = _ref$displayName === void 0 ? '' : _ref$displayName,
      _ref$rules = _ref.rules,
      rules = _ref$rules === void 0 ? {} : _ref$rules;

  if (!Object.keys(rules)) {
    return function () {};
  }

  var valueTester = function valueTester() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        type = _ref2.type,
        rawValue = _ref2.value,
        _ref2$currentErrors = _ref2.currentErrors,
        currentErrors = _ref2$currentErrors === void 0 ? [] : _ref2$currentErrors;

    // This will neatly trim non-empty string inputs]
    var value = !(0, _lodash.isNil)(rawValue) && (typeof rawValue === 'number' ? rawValue : rawValue.trim());
    var inputData = {
      value: value,
      name: displayName
    };

    if (!type) {
      // If an event type is NOT included then run validation on all unique rules
      var eventKeys = Object.keys(rules);
      var compiledRules = eventKeys.reduce(function (accum, key) {
        return [].concat(_toConsumableArray(accum), _toConsumableArray(rules[key]));
      }, []);

      var activeRuleSet = _toConsumableArray(new Set(compiledRules));

      var fieldData = Object.assign({}, inputData, {
        rules: activeRuleSet
      });

      var _inputValidator = (0, _inputValidator3.default)(_objectSpread(_objectSpread({}, fieldData), {}, {
        errors: []
      })),
          errors = _inputValidator.errors;

      return _toConsumableArray(new Set(errors));
    }

    if (Object.keys(rules).includes(type)) {
      // If an event type is included then only run validation on those rules
      var _activeRuleSet = rules[type];

      var _fieldData = Object.assign({}, inputData, {
        rules: _activeRuleSet
      });

      var _inputValidator2 = (0, _inputValidator3.default)(_objectSpread(_objectSpread({}, _fieldData), {}, {
        errors: []
      })),
          _errors = _inputValidator2.errors;

      return _toConsumableArray(new Set(_errors));
    } // This ensures that the old errors persist if an event does not have a ruleset associated with it


    return currentErrors;
  };

  return valueTester;
};

exports.validate = validate;
var _default = validate;
exports.default = _default;